/**
 * 레퍼런스 : https://github.kakaocorp.com/kakaopage/api/blob/58db0cf06dce37e800e5aee64250899a8684fb30/common/src/main/java/com/kakaopage/common/CommonCodes.java#L12
 */
export enum UserTypeVo {
  Normal = 'UT00', // 일반
  BlackList = 'UT01', // BlackList
}
